import {
  Badge,
  Button,
  Card,
  Divider,
  Flex,
  Heading,
  Text,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import StatusCheckComponent from "../common/StatusCheckComponent";
import { useMedicationsQuery } from "./api/useMedicationsQuery";
import { useUserQuery } from "../common/useUserQuery";
import CareNotesCard from "../common/CareNotesCard";

export default function MedicationsContainer() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const {
    data: medicationsData,
    isFetching,
    error,
  } = useMedicationsQuery(userQueryData?.patientUserId);

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return medicationsData?.map((medication) => {
    let diagnosisTags = [];
    try {
      diagnosisTags = JSON.parse(medication?.diagnosisTags || "[]");
      if (!Array.isArray(diagnosisTags)) {
        diagnosisTags = [];
      }
    } catch (error) {
      console.error("Error parsing detailsTags:", error);
      diagnosisTags = [];
    }
    return (
      <Card variation="elevated" key={`mc_m_${medication?.id}`}>
        <Flex direction="row" alignItems="center">
          <Heading level="5" children={medication?.medicationName}></Heading>
          <Button
            size="small"
            variation="primary"
            onClick={() =>
              navigate(`/user/hr/medications/${medication.id}/edit`)
            }
          >
            Edit
          </Button>
        </Flex>
        <Flex marginTop={12} direction={"row"}>
          <Badge size="small" variation="success">
            Begin Date: {medication.beginDate}
          </Badge>
          <Badge size="small">End Date: {medication.endDate}</Badge>
        </Flex>
        <Flex marginTop={12} shrink={1}>
          <Flex

            wrap={"wrap"}
          >
            <Badge size="small" variation="info">
              Usage:
              {medication.usage}
            </Badge>
            <Badge size="small" variation="info">
              Dosage: {medication.dosage}
            </Badge>
            <Badge size="small" variation="info">
              Status: {medication.status}
            </Badge>
            <Badge size="small" variation="info">
              Type: {medication.medicationType}
            </Badge>
            {diagnosisTags?.map((tag, index) => (
              <Badge key={`mc_dt_${index}`} size="small" variation="warning">
                {tag}
              </Badge>
            ))}
          </Flex>
        </Flex>
        <Flex marginTop={12}>
          <Text fontWeight={800}>Description:</Text>
          <Text>{medication?.medicationDescription}</Text>
        </Flex>
        <Flex direction={"column"} marginTop={12}>
          <CareNotesCard
            noteSection="HR_MEDICATIONS"
            objectId={medication?.id}
          />
        </Flex>
        <Flex marginTop={9} direction="column">
          <Divider size="small" />
          <StatusCheckComponent
            label={`${medication?.isActive === 1 ? "Active" : "Not Active"}`}
            isValid={medication?.isActive === 1}
          />
        </Flex>
      </Card>
    );
  });
}
